import { Suspense } from 'react'
import { createPortal } from 'react-dom'
import { Button, IconButton, ScrollArea, Text } from '~/shared/ui'
import { useFilterListVisibilityStore, useFilters } from '../../model'
import { FiltersContent } from './filters-content/filters-content'
import { LoadingSkeleton as FiltersContentLoadingSkeleton } from './filters-content/loading-skeleton'

export function Filters() {
  const { resetFilters } = useFilters()
  const { filtersFormVisible, setFiltersFormVisible } = useFilterListVisibilityStore()

  if (!filtersFormVisible) {
    return null
  }

  const close = () => {
    setFiltersFormVisible(false)
  }

  return createPortal(
    <ScrollArea className="bg-surface-lowest border-divider h-full w-[256px] shrink-0 border-l">
      <div className="bg-surface-lowest sticky top-0 z-1">
        <div className="flex h-[72px] items-center justify-between gap-3 px-4">
          <Text appearance="H6">Filters</Text>
          <IconButton
            container="small"
            materialIcon="close"
            onClick={close}
          />
        </div>
      </div>

      <Suspense fallback={<FiltersContentLoadingSkeleton />}>
        <FiltersContent />
      </Suspense>

      <div className="bg-surface-lowest border-divider sticky bottom-0 flex justify-end border-t p-4">
        <Button
          className="uppercase"
          onClick={resetFilters}
        >
          Clear filters
        </Button>
      </div>
    </ScrollArea>,
    document.getElementById('js-right-sidebar') as HTMLElement,
  )
}
